
import Blog1 from '../assets/images/news/trends_hr.png';
import Blog2 from '../assets/images/services/training.png';
import Blog3 from '../assets/images/services/sv-4.jpg';
import Blog4 from '../assets/images/services/sv-5.jpg';
import us_image from '../assets/images/news/comment_user.png';

export const newsData =
[
    {
        "id": 1,
        "title": "New Trends in HR for 2024",
        "date": "2024-05-15",
        "category": "Business",
        "comments": 5,
        "image": Blog1,
        "content": "As the business world evolves, new HR trends are emerging for 2024. Companies are focusing more on employee well-being, diversity and inclusion, and leveraging AI for recruitment processes. These trends are reshaping how businesses approach human resources and are essential for staying competitive in the market.",
        "desc1": "The importance of these trends cannot be overstated. With more companies recognizing the value of a diverse and inclusive workplace, efforts to promote these values are increasing. Additionally, the integration of AI in recruitment helps in identifying the best candidates efficiently.",
        "desc2": "Companies that stay ahead of these trends will not only enhance their HR practices but also boost overall business performance. Keeping up with these changes ensures that businesses can attract and retain top talent, which is crucial in today's competitive market.",
        "commentList": [
            { id:1,us_image:us_image,"user": "John Doe", "text": "Great insights, thank you!" },
            { id:2,us_image:us_image,"user": "Jane Smith", "text": "Very informative article." },
            { id:3,us_image:us_image,"user": "Charlie Davis", "text": "Very useful information, Regards." },
            { id:4,us_image:us_image,"user": "Roslyne Dana Johnny ", "text": "Happy to be well informed, Holla HillRocks" },
            { id:5,us_image:us_image,"user": "Alice Johnson", "text": "These strategies really work!" },
        ]
    },
    {
        "id": 2,
        "title": "Effective Employee Engagement Strategies",
        "date": "2024-04-28",
        "category": "Staffing",
        "comments": 3,
        "image": Blog2,
        "content": "Employee engagement is crucial for productivity and retention. In this article, we explore effective strategies to boost engagement, such as providing growth opportunities, fostering a positive work culture, and ensuring open communication. These strategies help create a motivated and committed workforce.",
        "desc1": "By providing employees with opportunities for growth, businesses can ensure that their workforce remains engaged and motivated. A positive work culture is also vital, as it fosters collaboration and innovation.",
        "desc2": "Open communication channels allow employees to voice their opinions and feel valued. These strategies, when implemented effectively, can lead to higher productivity and lower turnover rates.",
    "commentList": [
        { id:6,us_image:us_image,"user": "Alice Johnson", "text": "These strategies really work!" },
        { id:7,us_image:us_image,"user": "Bob Brown", "text": "I'll definitely try these out." },
        { id:8,us_image:us_image,"user": "Charlie Davis", "text": "Very useful information." },
    ]
    
},
    {
        "id": 3,
        "title": "Navigating Labor Laws in 2024",
        "date": "2024-03-10",
        "category": "Compliance",
        "comments": 2,
        "image": Blog3,
        "content": "Staying compliant with labor laws is vital for any business. This article provides an overview of the latest changes in labor regulations for 2024 and offers practical tips for ensuring compliance. Topics covered include wage laws, working hours, and employee rights.",
        "desc1": "Understanding these regulations can help businesses avoid legal issues and maintain a good reputation. It's essential to stay updated on changes to ensure all practices are compliant with the latest laws.",
        "desc2": "By implementing these compliance tips, businesses can create a fair and legal work environment. This not only protects the company from potential lawsuits but also promotes trust and reliability among employees.",
    "commentList": [
        { id:9,us_image:us_image,"user": "Charlie Davis", "text": "Very useful information." },
        { id:10,us_image:us_image,"user": "Christin Dana Petters ", "text": "Thanks for the tips!, It was amazing" }
    ]
},
    {
        "id": 4,
        "title": "The Role of Technology in Modern HR",
        "date": "2024-02-20",
        "category": "Technology",
        "comments": 4,
        "image": Blog4,
        "content": "Technology is transforming the HR landscape. From AI-driven recruitment to employee management systems, modern HR practices are becoming more efficient and data-driven. This article examines the latest technological advancements in HR and how they are helping businesses streamline their operations.",
        "desc1": "AI-driven recruitment systems can quickly analyze resumes and identify the best candidates, saving time and resources. Employee management systems allow for better tracking of employee performance and development.",
        "desc2": "These technologies not only improve efficiency but also provide valuable data insights that can drive strategic decisions. Embracing these advancements is crucial for staying competitive in today's market.",
       
        "commentList": [
            { id:11,us_image:us_image,"user": "Eve Black", "text": "Tech in HR is the future!" },
            { id:12,us_image:us_image,"user": "Frank Green", "text": "AI is a game changer." },
            { id:13,us_image:us_image,"user": "Charlie Davis", "text": "Very useful information." },
            { id:14,us_image:us_image,"user": "Robin Dana White", "text": "Thanks for the tips!" },
        ]
    }
]
